document.addEventListener('DOMContentLoaded', function () {
  const banner = document.getElementById('cookieBanner');
  const modalOverlay = document.getElementById('cookieModalOverlay');
  const agreeBtn = document.getElementById('cookieAgree');
  const detailsLink = document.getElementById('cookieDetailsLink');
  const closeModal = document.getElementById('cookieModalClose');

  if (!localStorage.getItem('cookieConsent')) {
    banner.style.display = 'flex';
    var jdivInterval = setInterval(function () {
        $('jdiv').hide();
    }, 1000);
  }

  agreeBtn.addEventListener('click', function () {
    localStorage.setItem('cookieConsent', 'true');
    banner.style.display = 'none';
    clearInterval(jdivInterval);
    $('jdiv').show();
  });

  detailsLink.addEventListener('click', function () {
    modalOverlay.style.display = 'flex';
  });

  closeModal.addEventListener('click', function () {
    modalOverlay.style.display = 'none';
  });

  modalOverlay.addEventListener('click', function (e) {
    if (e.target === modalOverlay) {
      modalOverlay.style.display = 'none';
    }
  });
});
